var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"dialog-2",attrs:{"visible":_vm.visible},on:{"opened":_vm.handleOpen,"update:visible":function($event){_vm.visible=$event}}},[_vm._t("default",[_c('p',[_vm._v("主体内容")])]),_c('div',{staticClass:"out-menu"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }